import React, { createContext, useContext, useState } from "react";

export const MODEL_TAB_PATHS = [
    "/",
    "/enclosure",
    "/airtightness",
    "/mechanicals",
    "/upgrades",
    "/review",
];

export const DEFAULT_MODEL_TAB = "/";
export const DEFAULT_INSIGHTS_TAB = "/room-by-room";

export const isModelTabPath = (path) => MODEL_TAB_PATHS.includes(path);

const LayoutContext = createContext({});

export const LayoutProvider = ({ children }) => {
    const [modelTabActive, setModelTabActive] = useState("/");
    const [insightsTabActive, setInsightsTabActive] = useState("/room-by-room");

    return (
        <LayoutContext.Provider
            value={{
                modelTabActive,
                setModelTabActive,
                insightsTabActive,
                setInsightsTabActive,
            }}
        >
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => useContext(LayoutContext);